import React, { useState, useEffect, useRef } from 'react';

import lpllogo from '../../assets/images/logo.png';
import user from '../../assets/images/user.png';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';

import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import SearchableSelect from '../../components/searchableSelect';
import DateRangePickerComponent from '../../components/date-range';
// import './../../assets/stylesheet/insights.scss';
import '../../assets/stylesheet/insights.scss'


import StackedSingleBarChart, { StackedSingleBarChart1 } from '../../components/stackedSingleBarChart';

import Exporttools from '../../components/exporttools';
import LineChart from '../../components/lineChart';
import Autocomplete from '../../components/autocomplete';
import GroupedBarChart from '../../components/groupbarChart';
import CombinedChartInsights from '../../components/stackedBarWithLineChartInsights';
import baseUrl from "../../services/baseUrl";
import ApiRequest from "../../services/apiService";
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import MyMultiSelectDropdown from "../../utilities/multiSelectInputType";
import GetUserData from '../../utilities/getUserDetails';
import GetFormattedDateTime from '../../utilities/getFormattedDateTime';
import SingleSelectTouchpointDropdown from '../Dashboard/DropDownSelectTouchpointInputType';
import SingleSelectSobDropDown from '../Dashboard/DropDownSelectSobInputType';
import ScreenLoader from '../../components/screenLoader';
import GroupedBarChartSecond from '../../components/groupbarChartSecond';


function Insights() {

    const [isScrolled, setIsScrolled] = useState(false);
    const handleScroll = () => {
        if (window.scrollY > 50) { // Adjust the value based on when you want to add the class
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const [setValue] = useState(null);
    const [userInfo, setUserInfo] = useState(GetUserData());
    const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || "");
    const [viewFilter, setViewFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState("");
    const [npsDistributionData, setNpsDistributionData] = useState({});
    const [drillDownNpsDistributionData, setDrillDownNpsDistributionData] = useState([]);
    const [l1DriverData, setL1DriverData] = useState({});
    const [drillDownL1DriverData, setDrillDownL1DriverData] = useState([]);
    const [responseYesNo, setResponseYesNo] = useState({});
    const [drillDownResponseYesNo, setDrillDownResponseYesNo] = useState([]);
    const [projects, setProjects] = useState([]);
    const location = useLocation();
    const query = queryString.parse(location.search);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
    const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
    const [isAllTouchPoints, setIsAllTouchpoints] = useState(
        (localStorage.getItem('touchpointFilter') || localStorage.getItem('isAllTouchpoints')) ? true : false
    );
    const [IsLoading, setIsLoading] = useState(false);

    const fetchData = async () => {
        setIsLoading(true);

        try {
            const params = new URLSearchParams({
                searchTerm: searchTerm,
                quickFilterRange: quickFilter,
                fromDate: localStorage.getItem('fromDate') || fromDate,
                toDate: localStorage.getItem('toDate') || toDate,
                projectFilter: projectFilter,
                viewFilter: viewFilter,
                userCode: GetUserData().UserCode,
                userRole: GetUserData().UserRole,
                filters: selectedFilters,
                touchpointFilter: touchpointFilter,
                sobFilter: sobFilter
            });
            const url = `${baseUrl()}/nps/GetInsightsData?${params.toString()}`;
            const response = await ApiRequest({ apiLink: url, method: 'GET' });
            if (response.Message === 'Success') {
                setIsLoading(false);

                setNpsDistributionData(response.Data.npsDistributionData || {});
                setDrillDownNpsDistributionData(response.Data.drillDownNpsDistributionData || []);
                setL1DriverData(response.Data.l1DriverData || {});
                setDrillDownL1DriverData(response.Data.drillDownL1DriverData || [])
                setResponseYesNo(response.Data.responseYesNo || {});
                setDrillDownResponseYesNo(response.Data.drillDownResponseYesNo || []);
                setProjects(response.Data.projects || []);
            } else {
                console.log('Failed to load data');
            }
        } catch (error) {
            console.error('Error fetching cloud data:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [viewFilter, quickFilter, projectFilter, fromDate, toDate, selectedFilters, sobFilter, touchpointFilter]);

    const handleDateRangeFilter = (startDate, endDate) => {
        if (startDate && endDate) {
            setFromDate(startDate.toISOString().split("T")[0]);
            setToDate(endDate.toISOString().split("T")[0]);
            setQuickFilter("");
        } else {
            setFromDate("");
            setToDate("");
        }
        localStorage.setItem('quickFilter', '');
        localStorage.setItem('fromDate', startDate.toISOString().split("T")[0]);
        localStorage.setItem('toDate', endDate.toISOString().split("T")[0]);
        // window.location.reload();
    };
    //QuickFilters
    const handleQuickFilter = async (event) => {
        const selectedValue = event.target.value;
        setFromDate('');
        setToDate('');
        setViewFilter('');
        setQuickFilter(selectedValue);
        localStorage.setItem('fromDate', '');
        localStorage.setItem('toDate', '');
        localStorage.setItem('quickFilter', selectedValue);
        window.location.reload();

    };
    var L1DriverDistributionPromoterData = [];
    var L1DriverDistributionPassiveDetractorData = [];
    var L1DriverDistributionPromoterTotal = 0;
    var L1DriverDistributionPassiveDetractorTotal = 0;
    if(projectFilter.split(',').includes('1')){
        L1DriverDistributionPromoterData = [
            { label: 'Centre ambience & hygiene', data: [l1DriverData.SCHygienePromoter] },
            { label: 'Empathetic behaviour of the staff during entire process', data: [l1DriverData.SCEmpatheticPromoter] },
            { label: 'Skill of technician while performing the medical procedure', data: [l1DriverData.SCSkillPromoter] },
            { label: 'Staff knowledge & attention during registration/billing', data: [l1DriverData.SCStaffPromoter] },
            { label: 'Overall time taken to complete the entire process', data: [l1DriverData.SCOverallPromoter] },
        ];
        L1DriverDistributionPassiveDetractorData = [
            { label: 'Centre ambience & hygiene', data: [l1DriverData.SCHygienePassiveDetractor] },
            { label: 'Empathetic behaviour of the staff during entire process', data: [l1DriverData.SCEmpatheticPassiveDetractor] },
            { label: 'Skill of technician while performing the medical procedure', data: [l1DriverData.SCSkillPassiveDetractor] },
            { label: 'Staff knowledge & attention during registration/billing', data: [l1DriverData.SCStaffPassiveDetractor] },
            { label: 'Overall time taken to complete the entire process', data: [l1DriverData.SCOverallPassiveDetractor] },
        ];
        L1DriverDistributionPromoterTotal = l1DriverData.SCHygienePromoter + l1DriverData.SCEmpatheticPromoter + l1DriverData.SCSkillPromoter + l1DriverData.SCStaffPromoter + l1DriverData.SCOverallPromoter;
        L1DriverDistributionPassiveDetractorTotal = l1DriverData.SCHygienePassiveDetractor + l1DriverData.SCEmpatheticPassiveDetractor + l1DriverData.SCSkillPassiveDetractor + l1DriverData.SCStaffPassiveDetractor + l1DriverData.SCOverallPassiveDetractor;
    }
    else if(projectFilter.split(',').includes('4')){
        L1DriverDistributionPromoterData = [
            { label: 'Excellent service', data: [l1DriverData.FTRExcellentPromoter] },
            { label: 'Great behaviour', data: [l1DriverData.FTRBehaviourPromoter] },
            { label: 'Expert knowledge', data: [l1DriverData.FTRKnowledgePromoter] },
            { label: 'Fast query resolution', data: [l1DriverData.FTRFastPromoter] },
            { label: 'Quality of resolution', data: [l1DriverData.FTRQualityPromoter] },
        ];
        L1DriverDistributionPassiveDetractorData = [
            { label: 'Long wait time', data: [l1DriverData.FTRTimePassiveDetractor] },
            { label: 'Advisor behaviour', data: [l1DriverData.FTRAdvisorPassiveDetractor] },
            { label: 'Query resolution time', data: [l1DriverData.FTRResolutionTimePassiveDetractor] },
            { label: 'Quality of resolution', data: [l1DriverData.FTRQualityPassiveDetractor] },
        ];
        L1DriverDistributionPromoterTotal = l1DriverData.FTRExcellentPromoter + l1DriverData.FTRBehaviourPromoter + l1DriverData.FTRKnowledgePromoter + l1DriverData.FTRFastPromoter + l1DriverData.FTRQualityPromoter;
        L1DriverDistributionPassiveDetractorTotal = l1DriverData.FTRTimePassiveDetractor + l1DriverData.FTRAdvisorPassiveDetractor + l1DriverData.FTRResolutionTimePassiveDetractor + l1DriverData.FTRQualityPassiveDetractor;
    }
    else if(projectFilter.split(',').includes('5')){
        L1DriverDistributionPromoterData = [
            { label: 'Excellent service', data: [l1DriverData.FTNRExcellentPromoter] },
            { label: 'Speedy issue resolution', data: [l1DriverData.FTNRSpeedyPromoter] },
            { label: 'Great behaviour', data: [l1DriverData.FTNRGreatPromoter] },
            { label: 'Quality of resolution', data: [l1DriverData.FTNRQualityPromoter] },
        ];
        L1DriverDistributionPassiveDetractorData = [
            { label: 'Advisor knowledge', data: [l1DriverData.FTNRAdvisorKnowledgePassiveDetractor] },
            { label: 'Advisor behaviour', data: [l1DriverData.FTNRBehaviourPassiveDetractor] },
            { label: 'Issue resolution time', data: [l1DriverData.FTNRIssuePassiveDetractor] },
            { label: 'Limited self-service options', data: [l1DriverData.FTNRSelfServicePassiveDetractor] },
            { label: 'No/Limited update received about the issue', data: [l1DriverData.FTNRNoLimitedPassiveDetractor] },
            { label: 'Quality of resolution', data: [l1DriverData.FTNRQualityPassiveDetractor] },
        ];
        L1DriverDistributionPromoterTotal = l1DriverData.FTNRExcellentPromoter + l1DriverData.FTNRSpeedyPromoter + l1DriverData.FTNRGreatPromoter + l1DriverData.FTNRQualityPromoter;
        L1DriverDistributionPassiveDetractorTotal = l1DriverData.FTNRAdvisorKnowledgePassiveDetractor + l1DriverData.FTNRBehaviourPassiveDetractor + l1DriverData.FTNRIssuePassiveDetractor + l1DriverData.FTNRSelfServicePassiveDetractor
        +l1DriverData.FTNRNoLimitedPassiveDetractor+l1DriverData.FTNRQualityPassiveDetractor;
    }
    const l1DriverChartDataPromoter = {
        labels: ['L1 Driver'],
        datasets: L1DriverDistributionPromoterData
    };
    const l1DriverChartDataPassiveDetractor = {
        labels: ['L1 Driver'],
        datasets: L1DriverDistributionPassiveDetractorData
    };
    const l1DriverChartColor = [
        '#E67E22', '#1ABC9C', '#34495E', '#2ECC71', '#9B59B6', '#2980B9',
        '#F39C12', '#8E44AD', '#3498DB', '#16A085', '#D35400', 
        '#C0392B', '#27AE60', '#F1C40F', '#95A5A6'
      ];
    const l1DrillDownLabels = drillDownL1DriverData.map(item => GetFormattedDateTime(item.RespondedOn));
    const SCHygienePromoter = drillDownL1DriverData.map(item => item.SCHygienePromoter);
    const SCEmpatheticPromoter = drillDownL1DriverData.map(item => item.SCEmpatheticPromoter);
    const SCSkillPromoter = drillDownL1DriverData.map(item => item.SCSkillPromoter);
    const SCStaffPromoter = drillDownL1DriverData.map(item => item.SCStaffPromoter);
    const SCOverallPromoter = drillDownL1DriverData.map(item => item.SCOverallPromoter);
    const SCHygienePassiveDetractor = drillDownL1DriverData.map(item => item.SCHygienePassiveDetractor);
    const SCEmpatheticPassiveDetractor = drillDownL1DriverData.map(item => item.SCEmpatheticPassiveDetractor);
    const SCSkillPassiveDetractor = drillDownL1DriverData.map(item => item.SCSkillPassiveDetractor);
    const SCStaffPassiveDetractor = drillDownL1DriverData.map(item => item.SCStaffPassiveDetractor);
    const SCOverallPassiveDetractor = drillDownL1DriverData.map(item => item.SCOverallPassiveDetractor);
    const FTRExcellentPromoter = drillDownL1DriverData.map(item => item.FTRExcellentPromoter);
    const FTRBehaviourPromoter = drillDownL1DriverData.map(item => item.FTRBehaviourPromoter);
    const FTRKnowledgePromoter = drillDownL1DriverData.map(item => item.FTRKnowledgePromoter);
    const FTRFastPromoter = drillDownL1DriverData.map(item => item.FTRFastPromoter);
    const FTRQualityPromoter = drillDownL1DriverData.map(item => item.FTRQualityPromoter);
    const FTRTimePassiveDetractor = drillDownL1DriverData.map(item => item.FTRTimePassiveDetractor);
    const FTRAdvisorPassiveDetractor = drillDownL1DriverData.map(item => item.FTRAdvisorPassiveDetractor);
    const FTRResolutionTimePassiveDetractor = drillDownL1DriverData.map(item => item.FTRResolutionTimePassiveDetractor);
    const FTRQualityPassiveDetractor = drillDownL1DriverData.map(item => item.FTRQualityPassiveDetractor);
    const FTNRExcellentPromoter = drillDownL1DriverData.map(item => item.FTNRExcellentPromoter);
    const FTNRSpeedyPromoter = drillDownL1DriverData.map(item => item.FTNRSpeedyPromoter);
    const FTNRGreatPromoter = drillDownL1DriverData.map(item => item.FTNRGreatPromoter);
    const FTNRQualityPromoter = drillDownL1DriverData.map(item => item.FTNRQualityPromoter);
    const FTNRAdvisorKnowledgePassiveDetractor = drillDownL1DriverData.map(item => item.FTNRAdvisorKnowledgePassiveDetractor);
    const FTNRBehaviourPassiveDetractor = drillDownL1DriverData.map(item => item.FTNRBehaviourPassiveDetractor);
    const FTNRSelfServicePassiveDetractor = drillDownL1DriverData.map(item => item.FTNRSelfServicePassiveDetractor);
    const FTNRIssuePassiveDetractor = drillDownL1DriverData.map(item => item.FTNRIssuePassiveDetractor);
    const FTNRNoLimitedPassiveDetractor = drillDownL1DriverData.map(item => item.FTNRNoLimitedPassiveDetractor);
    const FTNRQualityPassiveDetractor = drillDownL1DriverData.map(item => item.FTNRQualityPassiveDetractor);
    
    
    var L1DriverBarChartPromoterData = [];
    var L1DriverBarChartPassiveDetractorData = [];
    if(projectFilter.split(',').includes('1')){
        L1DriverBarChartPromoterData = [
            { label: 'Centre ambience & hygiene', data: SCHygienePromoter },
            { label: 'Empathetic behaviour of the staff during entire process', data: SCEmpatheticPromoter },
            { label: 'Skill of technician while performing the medical procedure', data: SCSkillPromoter },
            { label: 'Staff knowledge & attention during registration/billing', data: SCStaffPromoter },
            { label: 'Overall time taken to complete the entire process', data: SCOverallPromoter },
        ]
        L1DriverBarChartPassiveDetractorData = [
            { label: 'Centre ambience & hygiene', data: SCHygienePassiveDetractor },
            { label: 'Empathetic behaviour of the staff during entire process', data: SCEmpatheticPassiveDetractor },
            { label: 'Skill of technician while performing the medical procedure', data: SCSkillPassiveDetractor },
            { label: 'Staff knowledge & attention during registration/billing', data: SCStaffPassiveDetractor },
            { label: 'Overall time taken to complete the entire process', data: SCOverallPassiveDetractor },
        ]
    }
    else if(projectFilter.split(',').includes('4')){
        L1DriverBarChartPromoterData = [
            { label: 'Excellent service', data: FTRExcellentPromoter },
            { label: 'Great behaviour', data: FTRBehaviourPromoter },
            { label: 'Expert knowledge', data: FTRKnowledgePromoter },
            { label: 'Fast query resolution', data: FTRFastPromoter },
            { label: 'Quality of resolution', data: FTRQualityPromoter },
        ]
        L1DriverBarChartPassiveDetractorData = [
            { label: 'Long wait time', data: FTRTimePassiveDetractor },
            { label: 'Advisor behaviour', data: FTRAdvisorPassiveDetractor },
            { label: 'Query resolution time', data: FTRResolutionTimePassiveDetractor },
            { label: 'Quality of resolution', data: FTRQualityPassiveDetractor },
        ]
    }
    else if(projectFilter.split(',').includes('5')){
        L1DriverBarChartPromoterData = [
            { label: 'Excellent service', data: FTNRExcellentPromoter },
            { label: 'Speedy issue resolution', data: FTNRSpeedyPromoter },
            { label: 'Great behaviour', data: FTNRGreatPromoter },
            { label: 'Quality of resolution', data: FTNRQualityPromoter },
        ]
        L1DriverBarChartPassiveDetractorData = [
            { label: 'Advisor knowledge', data: FTNRAdvisorKnowledgePassiveDetractor },
            { label: 'Advisor behaviour', data: FTNRBehaviourPassiveDetractor },
            { label: 'Limited self-service options', data: FTNRSelfServicePassiveDetractor },
            { label: 'Issue resolution time', data: FTNRIssuePassiveDetractor },
            { label: 'No/Limited update received about the issue', data: FTNRNoLimitedPassiveDetractor },
            { label: 'Quality of resolution', data: FTNRQualityPassiveDetractor },
        ]
    }

    const l1DrillDownPromoterData = {
        labels: l1DrillDownLabels,
        datasets: L1DriverBarChartPromoterData
    };
    const l1DrillDownPassiveDetractorData = {
        labels: l1DrillDownLabels,
        datasets: L1DriverBarChartPassiveDetractorData
    };

    const l1DrilldownColor = [
        '#E67E22', '#1ABC9C', '#34495E', '#2ECC71', '#9B59B6', '#2980B9',
        '#F39C12', '#8E44AD', '#3498DB', '#16A085', '#D35400', 
        '#C0392B', '#27AE60', '#F1C40F', '#95A5A6'
    ];
    // chart data 3
    const responseYesNoChartData = {
        labels: [''],
        datasets: [
            { label: 'Yes', data: [responseYesNo.ResponseYes] },
            { label: 'No', data: [responseYesNo.ResponseNo] },
        ],
    };
    const responseYesNoChartColor = ['#F39C12', '#2ECC71'];
    const resYesNoDrillLabels = drillDownResponseYesNo.map(item => GetFormattedDateTime(item.RespondedOn))
    const yesDrillData = drillDownResponseYesNo.map(item => item.ResponseYes);
    const noDrillData = drillDownResponseYesNo.map(item => item.ResponseNo);

    const drillDownResponseYesNoChartData = {
        labels: resYesNoDrillLabels,
        datasets: [
            {
                label: 'Yes',
                data: yesDrillData,
            },
            {
                label: 'No',
                data: noDrillData,
            },

        ],
    };
    const drillDownResponseYesNoChartColor = [
        '#F39C12', '#2ECC71'
    ];
    
    // const metrics = [
    //     { label: 'Centre ambience & hygiene', key: 'CenterAmbienceHygiene' },
    //     { label: 'Staff knowledge & attention during registration/billing', key: 'StafKnowledgeAttention' },
    //     { label: 'Skill of technician while performing the medical procedure', key: 'SkillOfTechnician' },
    //     { label: 'Empathetic behaviour of the staff during entire process', key: 'EmpatheticBehaviourOfTheStaff' },
    //     { label: 'Great behaviour', key: 'GreatBehaviour' },
    //     { label: 'Expert Knowledge', key: 'ExpertKnowledge' },
    // ];

    var metricsPromoter = [];
    var metricsPassiveDetractor = [];
    if(projectFilter.split(',').includes('1')){
        metricsPromoter = [
            { label: 'Centre ambience & hygiene', key: 'SCHygienePromoter' },
            { label: 'Empathetic behaviour of the staff during entire process', key: 'SCEmpatheticPromoter' },
            { label: 'Skill of technician while performing the medical procedure', key: 'SCSkillPromoter' },
            { label: 'Staff knowledge & attention during registration/billing', key: 'SCStaffPromoter' },
            { label: 'Overall time taken to complete the entire process', key: 'SCOverallPromoter' },
        ]
        metricsPassiveDetractor = [
            { label: 'Centre ambience & hygiene', key: 'SCHygienePassiveDetractor' },
            { label: 'Empathetic behaviour of the staff during entire process', key: 'SCEmpatheticPassiveDetractor' },
            { label: 'Skill of technician while performing the medical procedure', key: 'SCSkillPassiveDetractor' },
            { label: 'Staff knowledge & attention during registration/billing', key: 'SCStaffPassiveDetractor' },
            { label: 'Overall time taken to complete the entire process', key: 'SCOverallPassiveDetractor' },
        ]
    }
    else if(projectFilter.split(',').includes('4')){
        metricsPromoter = [
            { label: 'Excellent service', key: 'FTRExcellentPromoter' },
            { label: 'Great behaviour', key: 'FTRBehaviourPromoter' },
            { label: 'Expert knowledge', key: 'FTRKnowledgePromoter' },
            { label: 'Fast query resolution', key: 'FTRFastPromoter' },
            { label: 'Quality of resolution', key: 'FTRQualityPromoter' },
        ]
        metricsPassiveDetractor = [
            { label: 'Long wait time', key: 'FTRTimePassiveDetractor' },
            { label: 'Advisor behaviour', key: 'FTRAdvisorPassiveDetractor' },
            { label: 'Query resolution time', key: 'FTRResolutionTimePassiveDetractor' },
            { label: 'Quality of resolution', key: 'FTRQualityPassiveDetractor' },
        ]
    }
    
    else if(projectFilter.split(',').includes('5')){
        metricsPromoter = [
            { label: 'Excellent service', key: 'FTNRExcellentPromoter' },
            { label: 'Speedy issue resolution', key: 'FTNRSpeedyPromoter' },
            { label: 'Great behaviour', key: 'FTNRGreatPromoter' },
            { label: 'Quality of resolution', key: 'FTNRQualityPromoter' },
        ]
        metricsPassiveDetractor = [
            { label: 'Advisor knowledge', key: 'FTNRAdvisorKnowledgePassiveDetractor' },
            { label: 'Advisor behaviour', key: 'FTNRBehaviourPassiveDetractor' },
            { label: 'Issue resolution time', key: 'FTNRIssuePassiveDetractor' },
            { label: 'No/Limited update received about the issue', key: 'FTNRNoLimitedPassiveDetractor' },
            { label: 'Limited self-service options', key: 'FTNRSelfServicePassiveDetractor' },
            { label: 'Quality of resolution', key: 'FTNRQualityPassiveDetractor' },
        ]
    }


    const handleFilterClick = (type) => {
        setSelectedFilters(prevFilters => {
            if (!Array.isArray(prevFilters)) {
                console.error("prevFilters is not an array:", prevFilters);
                return [type];
            }

            const newFilters = prevFilters.includes(type)
                ? prevFilters.filter(filter => filter !== type)
                : [...prevFilters, type];

            // Call onSearch immediately when filter is clicked
            setSelectedFilters(newFilters);
            return newFilters;
        });
    };

    const handleTouchpointFilter = (touchpoint) => {
        setTouchpointFilter(touchpoint);
        localStorage.setItem("touchpointFilter", touchpoint);
    }
    const handleSobFilter = (sob) => {
        setSobFilter(sob);
        localStorage.setItem("sobFilter", sob);
    }

    const handleAllTouchpointSelect = (isSelected) => {
        setSobFilter('');
        setIsAllTouchpoints(isSelected);
    }

    const handleProjectFilter = (event) => {
        const selectedOption = event.target.value;
        setProjectFilter(selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.setItem('projectFilter', selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.removeItem("sobFilter");
        localStorage.removeItem("touchpointFilter");
        window.location.reload();
    };
    const [primaryQuestion, setPrimaryQuestion] = useState('');
    const [L1QuestionPromoter, setL1QuestionPromoter] = useState('');
    const [L1QuestionPassiveDetractor, setL1QuestionPassiveDetractor] = useState('');

    const [isPromoterL1Details, setIsPromoterL1Details] = useState(false);
    const [isPassiveDetractorL1Details, setIsPassiveDetractorL1Details] = useState(false);
    
    const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
    useEffect(()=>{
        const currentProject = localStorage.getItem('projectFilter');
        
        if(currentProject.split(',').includes('1')){ 
            if (isSuburban) {
                    setPrimaryQuestion(
                        'Based on your Sample Collection Experience, would you recommend Suburban Diagnostics India Pvt Limited to your family/friends ?'
                    );
                } else {
                    setPrimaryQuestion(
                        'Based on your Sample Collection Experience, would you recommend Dr. Lal PathLabs to your family/friends ?'
                    );
            }          
            
            setL1QuestionPromoter('What did you like the most ?');
            setL1QuestionPassiveDetractor('What as per you requires our immediate attention for improvement ?');
        }
        else if(currentProject.split(',').includes('4')){
            if(isSuburban)
            {
                setPrimaryQuestion('Based on your Sample Collection Experience, would you recommend Suburban Diagnostics India Pvt Limited to your family/friends ?');
            }
            else{
            setPrimaryQuestion('Based on your Contact Centre Experience, would you recommend Dr. Lal PathLabs to your family/friends?');
            }
            setL1QuestionPromoter('What did you like the most?');
            setL1QuestionPassiveDetractor('In your opinion, what requires our immediate attention for improvement?');
        }
        else if(currentProject.split(',').includes('5')){
              if(isSuburban)
            {
                setPrimaryQuestion('Based on your Sample Collection Experience, would you recommend Suburban Diagnostics India Pvt Limited to your family/friends ?');

            }
            else{
            setPrimaryQuestion('How satisfied are you with the resolution provided by Dr. Lal PathLabs on your Query/Issue?');
            }
            setL1QuestionPromoter('What went well?');
            setL1QuestionPassiveDetractor('What did not work?');
        }
    },[])
    const handlePromoterL1ViewDetails = () => {
        if(isPromoterL1Details == true){
            setIsPromoterL1Details(false)
        }
        else{
            setIsPromoterL1Details(true)
        }
    };
    const handlePassiveDetractorL1ViewDetails = () => {
        if(isPassiveDetractorL1Details == true){
            setIsPassiveDetractorL1Details(false)
        }
        else{
            setIsPassiveDetractorL1Details(true)
        }
    };
    return (
        <>
            {IsLoading ? (
                <div className="screenLoader">
                    <ScreenLoader />
                </div>
            ) : (
                <section className='container-fluid mt-1'>
                    <div className='Page-title d-flex align-items-center'>
                        <h3 className='mb-2'>Insights</h3>
                            <div className='me-1 ms-2'>
                                <div className="did-floating-label-content me-1 mb-0">
                                    <select
                                        className="did-floating-select w-150px h-300"
                                        value={projectFilter}
                                        onChange={handleProjectFilter}
                                    >
                                        {/* <option value="">Select Project</option> */}
                                        {projects.map((project) => (
                                            <option key={project.ProjectId} value={project.ProjectId}>{project.ProjectName}</option>
                                        ))}
                                    </select>
                                    <label className="did-floating-label">
                                        Project Filter
                                    </label>
                                </div>
                            </div>
                            <div
                                className="did-floating-label-content mb-1 me-2">
                                <SingleSelectSobDropDown
                                    onSobSelect={handleSobFilter}
                                    onAllTouchpointSelect={handleAllTouchpointSelect}
                                />
                            </div>
                        <div
                            className={
                                (!isAllTouchPoints)
                                    ? "d-none did-floating-label-content mb-0"
                                    : "did-floating-label-content mb-0"
                            }>
                            <SingleSelectTouchpointDropdown
                                onTouchPointSelect={handleTouchpointFilter}
                            />
                        </div>
                        <div className='card-option ms-auto d-flex'>

                            <div className="did-floating-label-content me-2 mb-0">
                                <select
                                    className="did-floating-select w-100px h-30"
                                    value={quickFilter}
                                    onChange={handleQuickFilter}
                                >
                                    <option value={""}>Select Filter</option>
                                    <option>FTD</option>
                                    <option>WTD</option>
                                    <option>MTD</option>
                                    <option>QTD</option>
                                    <option>YTD</option>
                                </select>
                                <label className="did-floating-label">
                                    Quick Filter
                                </label>
                            </div>
                            <div className='did-floating-label-content mb-0'>
                                <DateRangePickerComponent
                                    onRangeSelect={handleDateRangeFilter}
                                    quickFilter={quickFilter} />
                            </div>
                        </div>

                    </div>
                    <div className='me-2 ms-12 mt-2'>
                        <Button
                            variant={selectedFilters.includes('10') ? "success ppdFiltersBtn" : "success"}
                            className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('10') ? 'active' : 'inactive'}`}
                            onClick={() => handleFilterClick('10')}
                        >
                            Promoters
                        </Button>
                        <Button
                            variant={selectedFilters.includes('8') ? "warning ppdFiltersBtn" : "warning"}
                            className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('8') ? 'active' : 'inactive'}`}
                            onClick={() => handleFilterClick('8')}
                        >
                            Passives
                        </Button>
                        <Button
                            variant={selectedFilters.includes('6') ? "danger ppdFiltersBtn" : "danger"}
                            className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('6') ? 'active' : 'inactive'}`}
                            onClick={() => handleFilterClick('6')}
                        >
                            Detractors
                        </Button>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card insights-card'>
                                <div className='card-body'>
                                    <div className='row g-2'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table  custom-table-vertical-center'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '420px' }}>Question</th>
                                                            <th style={{ width: '220px' }}>Distribution</th>
                                                            <th style={{ width: '100px' }}>Responses</th>
                                                            <th style={{ width: '100px' }}>NPS</th>
                                                            <th style={{ width: '100px' }}>Promoters</th>
                                                            <th style={{ width: '100px' }}>Passives</th>
                                                            <th style={{ width: '100px' }}>Detractors</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a href={'baseurl'} className='hyper-link'>
                                                                    {primaryQuestion}
                                                                </a>
                                                            </td>
                                                            <td >
                                                                <div className='touchpoint-chart'>
                                                                    <div style={{ width: '180px', height: '20px', margin: '0 auto' }}>
                                                                        <StackedSingleBarChart promoters={npsDistributionData.PromotersCount} passives={npsDistributionData.PassivesCount} detractors={npsDistributionData.DetractorsCount} />
                                                                    </div>
                                                                </div>

                                                            </td>
                                                            <td className='text-center'>{npsDistributionData.Responses}</td>
                                                            <td className='text-center'>
                                                                {npsDistributionData.NPS}
                                                            </td>
                                                            <td className='text-center'>
                                                                {npsDistributionData.PromotersCount}
                                                            </td>
                                                            <td className='text-center'>{npsDistributionData.PassivesCount}</td>
                                                            <td className='text-center'>{npsDistributionData.DetractorsCount}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='trends'>
                                                <h3>Trend</h3>
                                                <div className='trends-wrapper'>
                                                    <div className='trendsCharts mb-3'>
                                                        <div className='h-240'>
                                                            <CombinedChartInsights data={drillDownNpsDistributionData} />
                                                        </div>

                                                    </div>
                                                    <div className='trendsData'>
                                                        <div className='table-responsive custom-table-vertical-center'>
                                                            <table className='table table-sm table-bordered mb-0'>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='text-center'>Date</td>
                                                                        {drillDownNpsDistributionData.map((data, index) => (
                                                                            <td className='text-center' key={index}>{GetFormattedDateTime(data.RespondedOn)}</td>
                                                                        ))}
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='text-center'>NPS</td>
                                                                        {drillDownNpsDistributionData.map((data, index) => (
                                                                            <td className='text-center' key={index}>{data.NPS}</td>
                                                                        ))}
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='text-center'>Promoters</td>
                                                                        {drillDownNpsDistributionData.map((data, index) => (
                                                                            <td className='text-center' key={index}>
                                                                                <span className='d-block'>
                                                                                    {data.Responses > 0
                                                                                        ? ((data.PromotersCount / data.Responses) * 100).toFixed(2) + '%'
                                                                                        : 0}
                                                                                </span>
                                                                                <span className='d-block'>#{data.PromotersCount}</span>
                                                                                <span className='d-block'>
                                                                                    {index > 0 && data.PromotersCount !== drillDownNpsDistributionData[index - 1].PromotersCount ? (
                                                                                        <i className={`fa ${(((data.PromotersCount / data.Responses) * 100) < ((drillDownNpsDistributionData[index - 1].PromotersCount / drillDownNpsDistributionData[index - 1].Responses) * 100)) ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success'}`}></i>
                                                                                    ) : null}
                                                                                </span>
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='text-center'>Passives</td>
                                                                        {drillDownNpsDistributionData.map((data, index) => (
                                                                            <td className='text-center' key={index}>
                                                                                <span className='d-block'>
                                                                                    {data.Responses > 0
                                                                                        ? ((data.PassivesCount / data.Responses) * 100).toFixed(2) + '%'
                                                                                        : 0}
                                                                                </span>
                                                                                <span className='d-block'>#{data.PassivesCount}</span>
                                                                                <span className='d-block'>
                                                                                    {index > 0 && data.PassivesCount !== drillDownNpsDistributionData[index - 1].PassivesCount ? (
                                                                                        <i className={`fa ${(((data.PassivesCount / data.Responses) * 100) < ((drillDownNpsDistributionData[index - 1].PassivesCount / drillDownNpsDistributionData[index - 1].Responses) * 100)) ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success'}`}></i>
                                                                                    ) : null}
                                                                                </span>
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='text-center'>Detractors</td>
                                                                        {drillDownNpsDistributionData.map((data, index) => (
                                                                            <td className='text-center' key={index}>
                                                                                <span className='d-block'>
                                                                                    {data.Responses > 0
                                                                                        ? ((data.DetractorsCount / data.Responses) * 100).toFixed(2) + '%'
                                                                                        : 0}
                                                                                </span>
                                                                                <span className='d-block'>#{data.DetractorsCount}</span>
                                                                                <span className='d-block'>
                                                                                    {index > 0 && data.DetractorsCount !== drillDownNpsDistributionData[index - 1].DetractorsCount ? (
                                                                                        <i className={`fa ${(((data.DetractorsCount / data.Responses) * 100) < ((drillDownNpsDistributionData[index - 1].DetractorsCount / drillDownNpsDistributionData[index - 1].Responses) * 100)) ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success'}`}></i>
                                                                                    ) : null}
                                                                                </span>
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* second question */}
                    <div className='row mb-2'>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card insights-card'>
                                <div className='card-body'>
                                    <div className='row g-2'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table custom-table-vertical-center'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '150px' }}>Question</th>
                                                            <th style={{ width: '450px' }}>Distribution</th>
                                                            <th className='text-center' style={{ width: '150px' }}>Responses</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td onClick={handlePromoterL1ViewDetails} className='L1ViewDetails text-center'>
                                                                {L1QuestionPromoter}
                                                            </td>
                                                            <td >
                                                                <div className='touchpoint-chart'>
                                                                    <div style={{ width: '420px', height: '30px', margin: '0 auto' }}>
                                                                        <StackedSingleBarChart1 chartData={l1DriverChartDataPromoter} colors={l1DriverChartColor} />
                                                                    </div>
                                                                </div>

                                                            </td>
                                                            <td className='text-center'>{L1DriverDistributionPromoterTotal}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className={isPromoterL1Details?'trends':'d-none trends'}>
                                                <h3>Trend</h3>
                                                <div className='trends-wrapper'>
                                                    <div className='trendsCharts mb-3'>
                                                        <div className='h-240'>
                                                            <GroupedBarChart data={l1DrillDownPromoterData} barColors={l1DrilldownColor} />
                                                        </div>
                                                    </div>
                                                    <div className='trendsData'>
                                                        <div className='table-responsive custom-table-vertical-center'>
                                                            <table className='table table-sm table-bordered mb-0'>
                                                                <thead>
                                                                    <tr>
                                                                        <th className='text-center'>L1 Driver</th>
                                                                        {drillDownL1DriverData.map((data, index) => (
                                                                            <td className='text-center' key={`date-${index}`}>{GetFormattedDateTime(data.RespondedOn)}</td>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {metricsPromoter.map((metric, metricIndex) => (
                                                                        <tr key={`metric-${metricIndex}`}>
                                                                            <th className='text-center'>{metric.label}</th>
                                                                            {drillDownL1DriverData.map((data, index) => {
                                                                                var total = 0;
                                                                                var previousTotal = 0;
                                                                                if(projectFilter.split(',').includes('1')){
                                                                                    total = 
                                                                                    data.SCHygienePromoter + 
                                                                                    data.SCEmpatheticPromoter +
                                                                                    data.SCSkillPromoter + 
                                                                                    data.SCStaffPromoter + 
                                                                                    data.SCOverallPromoter;

                                                                                    previousTotal = index > 0 ? (
                                                                                        drillDownL1DriverData[index - 1].SCHygienePromoter +
                                                                                        drillDownL1DriverData[index - 1].SCEmpatheticPromoter +
                                                                                        drillDownL1DriverData[index - 1].SCSkillPromoter +
                                                                                        drillDownL1DriverData[index - 1].SCStaffPromoter +
                                                                                        drillDownL1DriverData[index - 1].SCOverallPromoter 
                                                                                    ) : 0;
                                                                                }
                                                                                else if(projectFilter.split(',').includes('4')){
                                                                                    total = 
                                                                                    data.FTRExcellentPromoter + 
                                                                                    data.FTRBehaviourPromoter +
                                                                                    data.FTRKnowledgePromoter +
                                                                                    data.FTRFastPromoter + 
                                                                                    data.FTRQualityPromoter;

                                                                                    previousTotal = index > 0 ? (
                                                                                        drillDownL1DriverData[index - 1].FTRExcellentPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTRBehaviourPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTRKnowledgePromoter +
                                                                                        drillDownL1DriverData[index - 1].FTRFastPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTRQualityPromoter
                                                                                    ) : 0;
                                                                                }
                                                                                else if(projectFilter.split(',').includes('5')){
                                                                                    total = 
                                                                                    data.FTNRExcellentPromoter + 
                                                                                    data.FTNRSpeedyPromoter +
                                                                                    data.FTNRGreatPromoter + 
                                                                                    data.FTNRQualityPromoter;

                                                                                    previousTotal = index > 0 ? (
                                                                                        drillDownL1DriverData[index - 1].FTNRExcellentPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTNRSpeedyPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTNRGreatPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTNRQualityPromoter +
                                                                                        drillDownL1DriverData[index - 1].FTNRAdvisorKnowledge + 
                                                                                        drillDownL1DriverData[index - 1].FTNRBehaviour + 
                                                                                        drillDownL1DriverData[index - 1].FTNRIssue + 
                                                                                        drillDownL1DriverData[index - 1].FTNRNoLimited +
                                                                                        drillDownL1DriverData[index - 1].FTNRSelfService
                                                                                    ) : 0;
                                                                                }
                                                                                

                                                                                var percentage = total > 0 ? ((data[metric.key] / total) * 100).toFixed(2):0;

                                                                                 

                                                                                const previousPercentage = index > 0 ? ((drillDownL1DriverData[index - 1][metric.key] / previousTotal) * 100).toFixed(2) : 0;

                                                                                return (
                                                                                    <td className='text-center' key={`percentage-${index}-${metricIndex}`}>
                                                                                        <span className='d-block'>{percentage || 0}%</span>
                                                                                        <span className='d-block'>
                                                                                            {index > 0 && percentage !== previousPercentage ? (
                                                                                                <i className={`fa ${percentage > previousPercentage ? 'fa-arrow-up text-success' : 'fa-arrow-down text-danger'}`}></i>
                                                                                            ) : null}
                                                                                        </span>
                                                                                        <span className='d-block'>#{data[metric.key]}</span>
                                                                                    </td>
                                                                                );
                                                                            })}
                                                                        </tr>
                                                                    ))}


                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table custom-table-vertical-center'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '150px' }}>Question</th>
                                                            <th style={{ width: '450px' }}>Distribution</th>
                                                            <th className='text-center' style={{ width: '150px' }}>Responses</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td onClick={handlePassiveDetractorL1ViewDetails} className='L1ViewDetails text-center'>
                                                                {L1QuestionPassiveDetractor}
                                                            </td>
                                                            <td >
                                                                <div className='touchpoint-chart'>
                                                                    <div style={{ width: '420px', height: '30px', margin: '0 auto' }}>
                                                                        <StackedSingleBarChart1 chartData={l1DriverChartDataPassiveDetractor} colors={l1DriverChartColor} />
                                                                    </div>
                                                                </div>

                                                            </td>
                                                            <td className='text-center'>{L1DriverDistributionPassiveDetractorTotal}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className={isPassiveDetractorL1Details?'trends':'d-none trends'}>
                                                <h3>Trend</h3>
                                                <div className='trends-wrapper'>
                                                    <div className='trendsCharts mb-3'>
                                                        <div className='h-240'>
                                                            <GroupedBarChart data={l1DrillDownPassiveDetractorData} barColors={l1DrilldownColor} />
                                                        </div>
                                                    </div>
                                                    <div className='trendsData'>
                                                        <div className='table-responsive custom-table-vertical-center'>
                                                            <table className='table table-sm table-bordered mb-0'>
                                                                <thead>
                                                                    <tr>
                                                                        <th className='text-center'>L1 Driver</th>
                                                                        {drillDownL1DriverData.map((data, index) => (
                                                                            <td className='text-center' key={`date-${index}`}>{GetFormattedDateTime(data.RespondedOn)}</td>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {metricsPassiveDetractor.map((metric, metricIndex) => (
                                                                        <tr key={`metric-${metricIndex}`}>
                                                                            <th className='text-center'>{metric.label}</th>
                                                                            {drillDownL1DriverData.map((data, index) => {
                                                                                var total = 0;
                                                                                var previousTotal = 0;
                                                                                if(projectFilter.split(',').includes('1')){
                                                                                    total = 
                                                                                    data.SCHygienePassiveDetractor + 
                                                                                    data.SCEmpatheticPassiveDetractor +
                                                                                    data.SCSkillPassiveDetractor + 
                                                                                    data.SCStaffPassiveDetractor + 
                                                                                    data.SCOverallPassiveDetractor;

                                                                                    previousTotal = index > 0 ? (
                                                                                        drillDownL1DriverData[index - 1].SCHygienePassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].SCEmpatheticPassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].SCSkillPassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].SCStaffPassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].SCOverallPassiveDetractor 
                                                                                    ) : 0;
                                                                                }
                                                                                else if(projectFilter.split(',').includes('4')){
                                                                                    total = 
                                                                                    data.FTRTimePassiveDetractor + 
                                                                                    data.FTRAdvisorPassiveDetractor + 
                                                                                    data.FTRResolutionTimePassiveDetractor +
                                                                                    data.FTRQualityPassiveDetractor;

                                                                                    previousTotal = index > 0 ? (
                                                                                        drillDownL1DriverData[index - 1].FTRTimePassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTRAdvisorPassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTRResolutionTimePassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTRQualityPassiveDetractor
                                                                                    ) : 0;
                                                                                }
                                                                                else if(projectFilter.split(',').includes('5')){
                                                                                    total = 
                                                                                    data.FTNRAdvisorKnowledgePassiveDetractor +
                                                                                    data.FTNRBehaviourPassiveDetractor +
                                                                                    data.FTNRIssuePassiveDetractor +
                                                                                    data.FTNRNoLimitedPassiveDetractor +
                                                                                    data.FTNRSelfServicePassiveDetractor +
                                                                                    data.FTNRQualityPassiveDetractor ;

                                                                                    previousTotal = index > 0 ? (
                                                                                        drillDownL1DriverData[index - 1].FTNRAdvisorKnowledgePassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTNRBehaviourPassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTNRIssuePassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTNRNoLimitedPassiveDetractor +
                                                                                        drillDownL1DriverData[index - 1].FTNRSelfServicePassiveDetractor + 
                                                                                        drillDownL1DriverData[index - 1].FTNRQualityPassiveDetractor 
                                                                                    ) : 0;
                                                                                }
                                                                                

                                                                                var percentage = total > 0 ? ((data[metric.key] / total) * 100).toFixed(2):0;

                                                                                 

                                                                                const previousPercentage = index > 0 ? ((drillDownL1DriverData[index - 1][metric.key] / previousTotal) * 100).toFixed(2) : 0;

                                                                                return (
                                                                                    <td className='text-center' key={`percentage-${index}-${metricIndex}`}>
                                                                                        <span className='d-block'>{percentage || 0}%</span>
                                                                                        <span className='d-block'>
                                                                                            {index > 0 && percentage !== previousPercentage ? (
                                                                                                <i className={`fa ${percentage > previousPercentage ? 'fa-arrow-up text-success' : 'fa-arrow-down text-danger'}`}></i>
                                                                                            ) : null}
                                                                                        </span>
                                                                                        <span className='d-block'>#{data[metric.key]}</span>
                                                                                    </td>
                                                                                );
                                                                            })}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* third question */}
                    <div className={projectFilter.includes('1')?'row mb-2':'d-none row mb-2'}>
                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                            <div className='card insights-card'>
                                <div className='card-body'>
                                    <div className='row g-2'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table custom-table-vertical-center'>
                                                <table className='table table-sm table-bordered mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '350px' }}>Question</th>
                                                            <th style={{ width: '300px' }}>Distribution</th>
                                                            <th className='text-center' style={{ width: '150px' }}>Responses</th>
                                                            <th className='text-center' style={{ width: '100px' }}>Yes</th>
                                                            <th className='text-center' style={{ width: '100px' }}>No</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className='text-center'>
                                                          {isSuburban ? (
  "Did you receive 9-digit bar code (Lab number) after sample collection by Suburban Diagnostics India Pvt Limited staff?"
) : (
  "Did you receive 9-digit bar code (Lab number) after sample collection by Dr. Lal PathLabs staff?"
)}

                                                            </td>
                                                            <td className='text-center'>
                                                                <div className='touchpoint-chart'>
                                                                    <div style={{ width: '280', height: '30px', margin: '0 auto' }}>
                                                                        <StackedSingleBarChart1 chartData={responseYesNoChartData} colors={responseYesNoChartColor} />
                                                                    </div>
                                                                </div>

                                                            </td>
                                                            <td className='text-center'>{responseYesNo.Responses}</td>
                                                            <td className='text-center'>{responseYesNo.ResponseYes}</td>
                                                            <td className='text-center'>{responseYesNo.ResponseNo}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className='trends'>
                                                <h3>Trend</h3>
                                                <div className='trends-wrapper'>
                                                    <div className='trendsCharts mb-3'>
                                                        <div className='h-240'>
                                                            <GroupedBarChart data={drillDownResponseYesNoChartData} barColors={drillDownResponseYesNoChartColor} />
                                                        </div>

                                                    </div>
                                                    <div className='trendsData'>
                                                        <div className='table-responsive custom-table-vertical-center'>
                                                            <table className='table table-sm table-bordered mb-0'>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='text-center'>Lab No. Received</td>
                                                                        {drillDownResponseYesNo.map((data, index) => (
                                                                            <td className='text-center' text-center key={index}>{GetFormattedDateTime(data.RespondedOn)}</td>
                                                                        ))}
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='text-center'>Yes</td>
                                                                        {drillDownResponseYesNo.map((data, index) => (
                                                                            <td className='text-center' key={index}>
                                                                                <span className='d-block'>{data.ResponseYes}</span>
                                                                                <span className='d-block'>
                                                                                    {/* {index > 0 && data.ResponseYes !== drillDownResponseYesNo[index - 1].ResponseYes ? (
                                                                                        <i className={`fa ${data.ResponseYes < drillDownResponseYesNo[index - 1].ResponseYes ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success'}`}></i>
                                                                                    ) : null} */}
                                                                                </span>
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='text-center'>No</td>
                                                                        {drillDownResponseYesNo.map((data, index) => (
                                                                            <td className='text-center' key={index}>
                                                                                <span className='d-block'>{data.ResponseNo}</span>
                                                                                <span className='d-block'>
                                                                                    {/* {index > 0 && data.ResponseNo !== drillDownResponseYesNo[index - 1].ResponseNo ? (
                                                                                    <i className={`fa ${data.ResponseNo < drillDownResponseYesNo[index - 1].ResponseNo ? 'fa-arrow-down text-danger' : 'fa-arrow-up text-success'}`}></i>
                                                                                ) : null} */}
                                                                                </span>
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            )}
        </>
    )
}
export default Insights;
